export const TOOLTIP_ICON_SIZE = 16;
export const TOOLTIP_MAX_WIDTH = 500;
export const TOOLTIP_TRANSITION_DURATION = 200;
export const TOOLTIP_CLOSE_DELAY_MS = 500;
export const TOOLTIP_OFFSET = 4;
